module.exports = __webpack_public_path__ + "img/14.cb2a59f0.jpg";